<template>
    <v-snackbar
      v-model="$store.state.snackbar_showing"
      :timeout="-1">
        {{$store.state.snackbar_message}}
        <v-btn icon color="white" @click="reset()">
              <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>

</template>
<script>
export default {
    data : () =>{
        return{
            timeout_value : 2000,
            timer : null,
        }
    },
    methods : {
        start_timer(){
            clearTimeout(this.timer);
            this.timer = setTimeout(()=>{
                this.reset();
            },this.timeout_value);
        },
        reset(){
            this.$store.commit('hideSnackbarMessage');
        }
    },
    computed :{
        messageChanged(){
            return this.$store.state.snackbar_message;
        }
    },
    watch:{
        '$store.state.snackbar_message' : function(){
            this.start_timer();
        }
    }
}
</script>